import { render, staticRenderFns } from "./FolderWorkflowStatus.vue?vue&type=template&id=59939399&scoped=true"
import script from "./FolderWorkflowStatus.vue?vue&type=script&lang=js"
export * from "./FolderWorkflowStatus.vue?vue&type=script&lang=js"
import style0 from "./FolderWorkflowStatus.vue?vue&type=style&index=0&id=59939399&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59939399",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCheckbox,VSkeletonLoader,VTab,VTabItem,VTabs,VTabsItems})
